export default "__VITE_ASSET__30f662d4__"